import { Field, useFormikContext } from 'formik';
import { Card } from '../../../../card/Card';
import { FormikSwitchWrapper } from '../../../../switch/FormikSwitchWrapper';
import {
  PipelineSettingsFormFields,
  PipelineSettingsFormState
} from '../../interfaces/pipeline-settings-form-state';
import { FormikTextField } from '../../../../input/FormikTextField/FormikTextField';

export function PipelineLatency({ disabled }: { disabled?: boolean }) {
  const { values } = useFormikContext<PipelineSettingsFormState>();

  const isLatencyEnabled = values[PipelineSettingsFormFields.LATENCY_THRESHOLD_ALERT_ENABLED];

  return (
    <Card
      gridColumns={1}
      className='mt-5'
      title='Pipeline Latency'
      subtitle='Latency is the difference between when data was created/updated at Source and loaded to
          your Destination'
    >
      <FormikSwitchWrapper
        dataId='latency-threshold'
        fieldName={PipelineSettingsFormFields.LATENCY_THRESHOLD_ALERT_ENABLED}
        label='Send alerts for Pipeline Latency'
        disabled={disabled}
      >
        Specify the latency threshold post which Hevo should send alert
      </FormikSwitchWrapper>

      {isLatencyEnabled ? (
        <Field
          name={PipelineSettingsFormFields.LATENCY_THRESHOLD}
          dataId='latency-minutes'
          label='Pipeline Latency (in minutes)'
          placeholder='Pipeline Latency (in minutes)'
          type='number'
          sx={{ width: '200px' }}
          disableDecimal
          required
          inlineError
          component={FormikTextField}
          disabled={disabled}
        />
      ) : null}
    </Card>
  );
}
